"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAskParams = exports.getSrcChunkAmount = exports.getEstimatedDelayBetweenChunksMillis = exports.getDeadline = exports.getMinimumDelayMinutes = exports.getFillDelay = exports.getMaxPossibleChunks = exports.getChunks = exports.getDuration = exports.getDestTokenMinAmount = exports.getDestTokenAmount = exports.DEFAULT_FILL_DELAY = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var consts_1 = require("./consts");
var types_1 = require("./types");
var utils_1 = require("./utils");
exports.DEFAULT_FILL_DELAY = { unit: types_1.TimeUnit.Minutes, value: consts_1.MIN_FILL_DELAY_MINUTES };
var getDestTokenAmount = function (srcAmount, limitPrice, srcTokenDecimals) {
    if (!srcAmount || !limitPrice || !srcTokenDecimals)
        return undefined;
    var result = (0, bignumber_js_1.default)(srcAmount).times(limitPrice);
    var decimalAdjustment = (0, bignumber_js_1.default)(10).pow(srcTokenDecimals);
    return result.div(decimalAdjustment).toFixed(0);
};
exports.getDestTokenAmount = getDestTokenAmount;
var getDestTokenMinAmount = function (srcChunkAmount, limitPrice, isMarketOrder, srcTokenDecimals) {
    if (isMarketOrder || !srcTokenDecimals || !srcChunkAmount || !limitPrice)
        return (0, bignumber_js_1.default)(1).toString();
    var result = (0, bignumber_js_1.default)(srcChunkAmount).times((0, bignumber_js_1.default)(limitPrice));
    var decimalAdjustment = (0, bignumber_js_1.default)(10).pow(srcTokenDecimals);
    var adjustedResult = result.div(decimalAdjustment);
    return bignumber_js_1.default.max(1, adjustedResult).integerValue(bignumber_js_1.default.ROUND_FLOOR).toFixed(0);
};
exports.getDestTokenMinAmount = getDestTokenMinAmount;
var getDuration = function (chunks, fillDelay, customDuration) {
    var minDuration = (0, utils_1.getTimeDurationMillis)(fillDelay) * 2 * chunks;
    var unit = (0, utils_1.findTimeUnit)(minDuration);
    return customDuration || { unit: unit, value: Number((0, bignumber_js_1.default)(minDuration / unit).toFixed(2)) };
};
exports.getDuration = getDuration;
var getChunks = function (maxPossibleChunks, isLimitPanel, typedChunks) {
    if (isLimitPanel === void 0) { isLimitPanel = false; }
    if (isLimitPanel)
        return 1;
    if (typedChunks !== undefined)
        return typedChunks;
    return maxPossibleChunks;
};
exports.getChunks = getChunks;
var getMaxPossibleChunks = function (config, typedSrcAmount, oneSrcTokenUsd, minChunkSizeUsd) {
    if (!typedSrcAmount || !oneSrcTokenUsd || !minChunkSizeUsd)
        return 1;
    var amount = (0, bignumber_js_1.default)(oneSrcTokenUsd).times(typedSrcAmount);
    var res = bignumber_js_1.default.max(1, amount.div(minChunkSizeUsd)).integerValue(bignumber_js_1.default.ROUND_FLOOR).toNumber();
    return res > 1 ? res : 1;
};
exports.getMaxPossibleChunks = getMaxPossibleChunks;
var getFillDelay = function (isLimitPanel, customFillDelay) {
    if (isLimitPanel === void 0) { isLimitPanel = false; }
    if (isLimitPanel || !customFillDelay)
        return exports.DEFAULT_FILL_DELAY;
    return customFillDelay;
};
exports.getFillDelay = getFillDelay;
var getMinimumDelayMinutes = function (config) {
    return (0, exports.getEstimatedDelayBetweenChunksMillis)(config) / 1000 / 60;
};
exports.getMinimumDelayMinutes = getMinimumDelayMinutes;
var getDeadline = function (currentTimeMillis, duration) {
    var minute = 60000;
    return currentTimeMillis + (0, utils_1.getTimeDurationMillis)(duration) + minute;
};
exports.getDeadline = getDeadline;
var getEstimatedDelayBetweenChunksMillis = function (config) {
    return config.bidDelaySeconds * 1000 * 2;
};
exports.getEstimatedDelayBetweenChunksMillis = getEstimatedDelayBetweenChunksMillis;
var getSrcChunkAmount = function (srcAmount, chunks) {
    if (!srcAmount || !chunks)
        return "0";
    return (0, bignumber_js_1.default)(srcAmount).div(chunks).integerValue(bignumber_js_1.default.ROUND_FLOOR).toFixed(0);
};
exports.getSrcChunkAmount = getSrcChunkAmount;
var getAskParams = function (config, args) {
    var fillDelayMillis = (0, utils_1.getTimeDurationMillis)(args.fillDelay);
    var fillDelaySeconds = (fillDelayMillis - (0, exports.getEstimatedDelayBetweenChunksMillis)(config)) / 1000;
    return [
        config.exchangeAddress,
        args.srcTokenAddress,
        args.destTokenAddress,
        (0, bignumber_js_1.default)(args.srcAmount).toFixed(0),
        (0, bignumber_js_1.default)(args.srcChunkAmount).toFixed(0),
        (0, bignumber_js_1.default)(args.destTokenMinAmount).toFixed(0),
        (0, bignumber_js_1.default)(args.deadline).div(1000).toFixed(0),
        (0, bignumber_js_1.default)(config.bidDelaySeconds).toFixed(0),
        (0, bignumber_js_1.default)(fillDelaySeconds).toFixed(0),
        [],
    ].map(function (it) { return it.toString(); });
};
exports.getAskParams = getAskParams;
